import styled from 'styled-components'

import { Layout } from '@loadsmart/miranda-react'

/**
 * The hero, the product tabs and the report cards all share one column so
 * their edges line up down the page.
 */
const CONTENT_MAX_WIDTH = '980px'

export const StyledContainer = styled(Layout.Box)`
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH};
  margin: 0 auto;
`

export const StyledHeroIllustration = styled.img`
  width: 200px;
  height: auto;
`

export const StyledContentColumn = styled(Layout.Stack)`
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH};
  margin: 0 auto;
`

/**
 * A framed mini-preview of the report, sized so every card in the list has
 * the same thumbnail footprint. The image is contained rather than cropped —
 * a report thumbnail is there to be read, not to fill a shape.
 */
export const StyledReportImage = styled.img<{ $disabled?: boolean }>`
  flex: 0 0 200px;
  width: 200px;
  aspect-ratio: 4 / 3;
  object-fit: contain;
  box-sizing: border-box;
  padding: 6px;
  background-color: rgb(var(--m-color-background-primary));
  border-radius: var(--m-border-radius-m);
  border: var(--m-border-thin) solid rgb(var(--m-color-border));
  opacity: ${props => (props.$disabled ? 0.4 : 1)};
  filter: ${props => (props.$disabled ? 'grayscale(100%)' : 'none')};
  transition:
    opacity 0.2s ease,
    filter 0.2s ease;
`

/**
 * The description arrives as markdown — a lead paragraph plus a short bullet
 * list. Browser defaults give both far more room than the card wants, so the
 * spacing is set here instead.
 */
export const StyledReportDescription = styled.div`
  p {
    margin: 0 0 var(--m-spacing-2);
  }

  ul,
  ol {
    margin: 0;
    padding-left: var(--m-spacing-4);
  }

  li {
    line-height: var(--m-line-height-6);
  }

  > :last-child {
    margin-bottom: 0;
  }
`

/**
 * Miranda's page empty state is a fixed-width block, so on its own it lands
 * against the left edge of the report column. Centre it in the column.
 */
export const StyledEmptyResults = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--m-spacing-10) 0;
`
